import buildDataXml from "./sharePointList.data.xml.builder";

const queryWithCheck = async (connectionName, implementation, shpAccess, queryParams) => {
    try {
        return await implementation.query(
            shpAccess,
            queryParams,
        );
    } catch (error) {
        console.error('Error occurred trying to execute query.', error);
        throw new Error('Failed to execute connection: ' + connectionName + '\r\nError: ' + error.message || '(unknown error)');
    }
}

const queryListData = async (
    connectionName,
    implementation,
    queryParams,
    shpAccess,
    isListForm,
    dom,
) => {
    const data = await queryWithCheck(
        connectionName,
        implementation,
        shpAccess,
        queryParams,
    );

    return buildDataXml(
        dom,
        implementation,
        isListForm,
        queryParams.fieldDefinitions,
        data,
    );
};

export default queryListData;
